import { render, staticRenderFns } from "./CrosswordSolver.vue?vue&type=template&id=57e845ec&scoped=true"
import script from "./CrosswordSolver.vue?vue&type=script&lang=js"
export * from "./CrosswordSolver.vue?vue&type=script&lang=js"
import style0 from "./CrosswordSolver.vue?vue&type=style&index=0&id=57e845ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e845ec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CrosswordSolverForm: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Forms/CrosswordSolverForm.vue').default,CircleLoader: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/CircleLoader.vue').default,WfChip: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/WfChip.vue').default,CrosswordPublisherGridList: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/crossword/CrosswordPublisherGridList.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default,ScrollTriggeredModal: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/crossword/ScrollTriggeredModal.vue').default})
